import genericRule from '../../namespace/relation/willRemove_namespace_relation';

export default {
    ...genericRule,
    excludedNamespaceRelations: [],
    namespace: 'application',
    relation: 'savedFilter'
};
